import {useMemo} from 'react';

import {type LogLabelFilterOption} from '../LogLabelFilter';
import {type LogLineData} from '../LogLineRenderer';

/**
 * useVisibleLogs computes the visible list of logs based on the current loading
 * state and selected label filters.
 */
export function useVisibleLogs(
  lines: readonly LogLineData[],
  selectedLabels: readonly LogLabelFilterOption[],
  loading: boolean
) {
  const all = useMemo(() => (loading ? [] : lines), [loading, lines]);

  const filtered = useMemo(() => {
    return selectedLabels.length
      ? all.filter(({label}) =>
          selectedLabels.some(({value}) => value === label)
        )
      : all;
  }, [all, selectedLabels]);

  return {
    all,
    filtered,
  };
}
